<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row">
      <div
        class="col-12"
      >
        <label class="offcanvas-header-text w-100" style="text-align: left">
          Select Placeholders
        </label>
        <div
          class="input-group offcanvas-border-primary border rounded-2"
          title="Using format option"
        >
          <button
            type="button"
            class="form-control input-lg offcanvas-primary border-0 d-flex align-items-center justify-content-center"
            (click)="openSelector(selectorIcons)"
          >
            <i
              class="fs-4"
              [class]="
                placeholder_icon?.type == 'mir' ? 'material-icons-outlined' : 'material-icons'
              "
            >
              {{ placeholder_icon?.id }}
            </i>
          </button>
          <button
            type="button"
            class="btn offcanvas-primary dropdown-toggle dropdown-toggle-split border-0"
            (click)="openSelector(selectorIcons)"
          >
            <i class="mdi mdi-chevron-down"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #selectorIcons let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">
      {{ iconType ? "Choose Trailing Icon" : "Choose Leading Icon" }}
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="modalRef?.hide()"
    ></button>
  </div>
  <div class="modal-body">
    <app-icons-selector
      (selectedIcon)="iconChange($event)"
    ></app-icons-selector>
  </div>
</ng-template>
